enum PaymentMethodId {
    Adyen = 'adyen',
    AdyenV2 = 'adyenv2',
    AdyenV2GooglePay = 'googlepayadyenv2',
    Affirm = 'affirm',
    Afterpay = 'afterpay',
    Amazon = 'amazon',
    AmazonPay = 'amazonpay',
    Barclaycard = 'barclaycard',
    BlueSnapV2 = 'bluesnapv2',
    Bolt = 'bolt',
    Braintree = 'braintree',
    AuthorizeNetGooglePay = 'googlepayauthorizenet',
    BraintreeGooglePay = 'googlepaybraintree',
    BraintreeVisaCheckout = 'braintreevisacheckout',
    CCAvenueMars = 'ccavenuemars',
    ChasePay = 'chasepay',
    Checkoutcom = 'checkoutcom',
    CheckoutcomGooglePay = 'googlepaycheckoutcom',
    Converge = 'converge',
    Klarna = 'klarna',
    Laybuy = 'laybuy',
    Masterpass = 'masterpass',
    PaypalExpress = 'paypalexpress',
    PaypalPaymentsPro = 'paypal',
    PaypalCommerce = 'paypalcommerce',
    PaypalCommerceCredit = 'paypalcommercecredit',
    SagePay = 'sagepay',
    Sezzle = 'sezzle',
    SquareV2 = 'squarev2',
    StripeGooglePay = 'googlepaystripe',
    StripeV3 = 'stripev3',
    Zip = 'zip',
}

export default PaymentMethodId;
